export * from './ui';
export * from './random';
export * from './apiClient';
export * from './time';
export * from './stringManipulation';

export const doDownload = (href: string, fileName: string): void => {
    const link = document.createElement('a');
    link.href = href;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    if (link.parentElement) {
        link.parentElement.removeChild(link);
    }
};

export const doDownloadAsync = async (
    href: string,
    fileName: string,
    throwException?: boolean,
    returnFalseIfNoData?: boolean
): Promise<boolean> => {
    try {
        const response = await fetch(href);

        if (!response.ok) {
            throw new Error('Download failed.');
        }

        const blob = await response.blob();

        if (returnFalseIfNoData && blob.size <= 1) {
            return false;
        }

        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.parentElement?.removeChild(link);

        window.URL.revokeObjectURL(url);
        return true;
    } catch (error) {
        console.error('Download error:', error);
        if (throwException) {
            throw error;
        }
        return true;
    }
};
